
import React, { Component } from 'react'
import {compose} from 'redux'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { filterArrayOfObjects } from '../../../../../../utils'
import Table from '@material-ui/core/Table'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper';
import SessionListHeader from './SessionListHeader'
import SessionListBody from './SessionListBody'
import SessionListFooter from './SessionListFooter'
import SessionListFilter from  '../SessionListFilter'
import {translate} from 'react-i18next'


const styles = theme => ({
  root: {
    overflowX: 'auto',
    boxShadow: 'none'
  },
  table: {
    minWidth: 300,
  }
});

class DesktopSessionList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      page:0,
      rowsPerPage: 10,
      currentSort: 'caseId',
      sortDirection: 'asc',
      filter: '',
      isProfileModalOpened: false
    }
  }

  /* PAGINATION */
  handleChangePage = (event, page) => {
    this.setState({ page })
  }

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value })
  }
  /*  */

  /* COLUMN SORTING */
  compareBy = key => {
    return (a, b) => {
      if (key !== 'startTime' && key !== 'endTime') {
        if (a[key] < b[key]) return -1
        if (a[key] > b[key]) return 1
      } else { // May contain null dates push those to bottom of sort
        if (a[key] === null) {
          return 1
        } else if (b[key] === null) {
          return -1
        } else { // Dates are stored as strings convert to truly compare
          return new Date(b[key]) - new Date(a[key])
        }
      }
      return 0
    }
  }

  handleSort = (col) => {
    const { currentSort, sortDirection } = this.state
    let direction = 'asc'
    if (currentSort === col) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc'
    }
    this.setState({
      sortDirection: direction,
      currentSort: col
    })
  }

  sortSessions = (sessions, col, direction) => {
    const sortedData = sessions.sort(this.compareBy(col))
    return direction === 'desc' ? sortedData.reverse() : sortedData
  }
  /*  */

  /* INPUT FILTER */
  handleFilterChange = filter => this.setState({ filter })
  /* */

  render() {
    const { recallSession, classes, onClickViewProfile } = this.props
    const { page, rowsPerPage, currentSort, sortDirection, filter } = this.state
    const { handleChangePage, handleChangeRowsPerPage, sortSessions, handleSort, handleFilterChange } = this
    let sessions = [...this.props.sessions]
    sessions = filterArrayOfObjects(sessions, filter)
    sessions = sortSessions(sessions, currentSort, sortDirection)

    return (
      <Paper className={classes.root}>
        <Grid container justify="flex-end">
          <SessionListFilter onChange={handleFilterChange} />
        </Grid>
        <Table
          className={classes.table}
          padding={'none'}
        >
          <SessionListHeader
            currentSort={currentSort}
            sortDirection={sortDirection}
            sortFn={handleSort}
          />
          <SessionListBody
            recallSession={recallSession}
            sessions={sessions.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
            onClickViewProfile={onClickViewProfile}

          />
          <SessionListFooter
            length={sessions.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Table>
      </Paper>
    )
  }
}

DesktopSessionList.propTypes = {
  sessions: PropTypes.array,
  classes: PropTypes.object,
  recallSession: PropTypes.func,
  t: PropTypes.func.isRequired
}

export default compose(
  withStyles(styles),
  translate()
)(DesktopSessionList)


// WEBPACK FOOTER //
// ./src/components/setup/recall-session/by-decision/SessionList/Desktop/SessionList.js